export const USER_LOGIN = "@login/USER_LOGIN";
export const USER_UPDATE = "@login/USER_UPDATE"